import moment from "moment-timezone";

const months = ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sept', 'okt', 'nov', 'dec'];
const fullMonths = ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'];

export function convertTimestampToDateAndTime(timestamp: any) {
    if (!timestamp) return '';

    const b = moment.tz(timestamp, 'UTC');
    const a = b.clone().tz('Europe/Amsterdam');

    let year: any = a.year();
    let month: any = months[a.month()];
    let date: any = lessThan10(a.date());
    let hour: any = lessThan10(a.hours());
    let min: any = lessThan10(a.minutes());
    
    return date + ' ' + month + ' ' + year + ' ' + hour + ':' + min;
}

export const convertDateToBirth = (date: Date) => {
    const dateObject = new Date(date);
    const yyyy = dateObject.getFullYear();
    let mm = dateObject.getMonth();
    let dd: any = dateObject.getDate();

    return `${dd} ${fullMonths[mm]} ${yyyy}`;
}

export const convertDateToYear = (date: Date) => {
    const dateObject = new Date(date);
    return dateObject.getFullYear();
}

export const convertDateToMonthAndYear = (date: Date) => {
    const dateObject = new Date(date);
    const yyyy = dateObject.getFullYear();
    let mm = dateObject.getMonth();

    return `${months[mm]} ${yyyy}`;
}

export const calculateTimeDifference = (date1: any, date2: any) => {
    date1 = new Date(date1);
    date2 = !date2 ? new Date() : new Date(date2);

    let output = '';
    let monthDiff = date2.getMonth() - date1.getMonth() + 12 * (date2.getFullYear() - date1.getFullYear());
    monthDiff += date2.getDate() > 15 ? 1 : 0;

    const years = Math.floor(monthDiff /  12);
    const months = monthDiff % 12;
    if (years > 0) {
        output += years + ' jaar';
    }

    if (years > 0 && months > 0) {
        output += ' en ';
    }

    if (months > 0) {
        output += months + (months == 1 ? ' maand' : ' maanden');
    }

    if (years <= 0 && months <= 0) {
        output = "0 maanden";
    }

    return output;
}

function lessThan10(number: number) {
    return number < 10 ? '0' + number : number;
}